export default __webpack_public_path__ + "static/media/bg-masthead-2-480w.07b8c21c.webp";